import React from 'react';
import { X } from 'lucide-react';
interface AISidebarProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  title?: string;
}
export const AISidebar: React.FC<AISidebarProps> = ({
  children,
  isOpen,
  onClose,
  title = 'Suggerimenti AI'
}) => {
  return <>
      {/* Backdrop with blur */}
      {isOpen && <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={onClose} data-id="element-150"></div>}

      {/* Drawer */}
      <aside className={`fixed top-0 right-0 h-full w-full sm:w-[400px] bg-white shadow-xl z-50 overflow-y-auto transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-151">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 p-4 flex items-center justify-between z-10" data-id="element-152">
          <h2 className="text-base font-semibold text-gray-900" data-id="element-153">{title}</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-154">
            <X className="h-5 w-5 text-gray-500" data-id="element-155" />
          </button>
        </div>

        {/* Content */}
        <div className="p-4" data-id="element-156">{children}</div>
      </aside>
    </>;
};